import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface AddModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  children: React.ReactNode;
  submitLabel?: string;
  submitDisabled?: boolean;
}

const AddModal: React.FC<AddModalProps> = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  children,
  submitLabel = 'Add',
  submitDisabled = false,
}) => (
  <Modal isOpen={isOpen} toggle={onClose} size="xl">
    <ModalHeader toggle={onClose}>{title}</ModalHeader>
    <form onSubmit={onSubmit}>
      <ModalBody className="p-4 d-flex flex-column gap-3">{children}</ModalBody>
      <ModalFooter>
        <button type="submit" className="btn btn-success" disabled={submitDisabled}>
          {submitLabel}
        </button>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
      </ModalFooter>
    </form>
  </Modal>
);

export default AddModal;
